module.exports = function atoa(a, n) {
  return Array.prototype.slice.call(a, n);
};



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-draggable/src/lib/atoa.js